<script>
    const date = new Date().getFullYear();
    import secondaryLogo from "$lib/assets/images/logos/c2-logo-check-white.svg";
    import ExtraNavLinks from "./ExtraNavLinks.svelte";
</script>

<footer>
    <div class="footer-container m-2">
        <img class="logo" src={secondaryLogo} alt="c2 certification logo" />
        <ExtraNavLinks />
        <div class="copyright">{date} &copy; C2 Certification. All Rights Reserved.</div>
    </div>
</footer>

<style>
    footer {
        width: 100%;
        display: flex;
        justify-content: center;
        padding: 50px 20px;
        background-color: #272d5b;
        color: #fff;
    }
    .footer-container {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        max-width: 1300px;
        width: 100%;
        gap: 40px;
    }
    .logo {
        width: 100px;
    }
    .copyright {
        font-size: 12px;
        opacity: 0.25;
    }
</style>
